
// @ts-nocheck





import { i18nText } from '@/locales';


import { Component, Vue } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import BaseDataForm from '@/UI/components/Helpers/BaseForm/BaseDataForm.vue';
import AppFilterTable from '@/UI/components/extFilter/AppFilterTable.vue';
import PageTitle from '@/UI/components/common/PageTitle.vue';
import {FiltersData} from '@/entity/filters/extFilter';
import { Button, Menu, List, Table, Select, Tabs, Modal, FormModel, Row } from 'ant-design-vue';
import { RouterNameEnum } from '@/router/router.types';
import { TableColumns } from "@/UI/pages/clients/lib/table";
import { ClientsAccountsAllStore } from '@/store/modules/ClientsAccountsAll';
import { SalonsStore } from '@/store/modules/Salons';
import {appFiltersStore} from "@/store/modules/appFilters";
import {FiltersData} from "@/entity/filters/extFilter";
import {getStudioId} from "@/UI/lib/state";
import SortComponent from "@/UI/components/Helpers/components/SortComponent.vue"
import FilterTableComponent from "@/UI/components/Helpers/filterAndSorted/FilterTableComponent.vue"
import {appPaginationStore} from "@/store/modules/appPagination";
import {ProxyGetData} from "@/UI/components/Helpers/getData";
import {DisplayMasks} from "@/UI/mixins/DisplayMasks";

@Component({
    components: {
        BaseDataForm,
        PageTitle,
        AppFilterTable,
        SortComponent,
        FilterTableComponent,
        'a-row': Row,
        'a-button': Button,
        'a-menu-item': Menu.Item,
        'a-list-item': List.Item,
        'a-list-item-meta': List.Item.Meta,
        'a-select': Select,
        'a-select-option': Select.Option,
        'a-table': Table,
        'a-tab': Tabs,
        'a-tab-pane': Tabs.TabPane,
        'a-modal': Modal,
        'a-form-model': FormModel,
        'a-form-model-item': FormModel.Item,
    },
})
export default class ClientsAccounts extends mixins(
    DisplayMasks,
    TableColumns,
    ProxyGetData,
    appPaginationStore
) {
    filtersData = new FiltersData();
    RouterNames = RouterNameEnum;

    async created(): Promise<void> {
        try {

            this.formReady = false
            this.tableLoad = false

            this.proxyFilter = {}
            appPaginationStore.setCurrent(1)
            await this.sortedData('desc', {dataIndex: 'created_at'})

            await this.fetchModules([
                {s: 'salons',  p: {limit: -1}},
                //{s: 'clientsAccountsAll', p: {limit: this.AppPageParams.pageSize}}
            ])
            this.setFilters(this)

        } catch (e) {
            console.error(e)
        } finally {
            this.formReady = true
            this.tableLoad = true
        }
    }

    get clientAccount(): any  { return ClientsAccountsAllStore.items }
    get salon(): any { return SalonsStore.salons }

    async clearAFilter(): void {
        this.proxyFilter = {
            salon_id: getStudioId(this)
        }
        await this.sortedData('desc', {dataIndex: 'created_at'})
        for (let i of this.filterData) {
            if(i) {
                if(i.default_value) {
                    i.default_value = [i18nText("Не указано")];
                } else {
                    i.defaultValue = i18nText("Не указано");
                }
            }
        }
    }

    async clearFilter(clear: string): void {
        await this.sortedData('desc', {dataIndex: 'created_at'})
    }

    setFilters(that: any): void {
        this.filtersData.filters.push(
            {
                key: 1,
                type: "sourceVuex",
                vuexSource: "salons",
                storeVuexSource: "salons",
                label: i18nText("Студия"),
                default_value: [i18nText("Не указано")],
                async onChange(value: any) {
                    if (value != 0) {
                        await that.filterData({
                            salon_id: value
                        });
                    }
                    else {
                        await that.fetchModule([{s: 'salons',  p: {limit: -1}}])
                        await that.filterData({});
                    }
                },
                async onSearch(value: any) {
                    if (value != "") {
                        await that.fetchModule([
                            {s: 'salons', p: {filter: {name: value, limit: -1}}}
                        ])
                    }
                    else {
                        await that.fetchModule([{s: 'salons',  p: {limit: -1}}])
                        //thisRef.$forceUpdate()
                    }
                    that.refreshPagination();
                }
            },
            {
                key: 2,
                type: 'input',
                label: i18nText("Имя или телефон владельца сети"),
                defaultValue: 0,
                placeholder: i18nText("Имя или телефон владельца сети"),
                filtered: false,
                fieldNames: ['target_value'],
                async onChange(value: any) {
                    await that.filterData({
                        search: value.target.value
                    });
                },
            },
            {
                key: 3,
                type: "range-input",
                label: i18nText("Баланс"),
                defaultValue: 0,
                value: [],
                source: [],
                fieldNames: ['sold'],
                filtered: false,
                async okRange(key1: any, key2: any) {
                    await that.filterData({
                        balance_from: key1,
                        balance_to: key2
                    })
                },
            },
        )
        this.filter_load = true
    }

    async setFilter({by, sort}: { by: string; sort: any }): Promise<void> {
        await this.filterData(appFiltersStore.filter)
        await this.sortedData(by, {dataIndex: sort.dataIndex})
    }

    async clearFilter(clear: string): Promise<void> {
        await this.sortedData('desc', {dataIndex: 'created_at'})
    }

    async clearAFilter(): Promise<void> {
        console.log("clearAFilter")
        this.proxyFilter = {
            salon_id: getStudioId(this)
        }
        for (let i of this.filtersData.filters) {
            i.default_value = [i18nText("Не указано")]
        }
        await this.sortedData('desc', {dataIndex: 'created_at'})
    }

}
